import React from "react";

const Home = () => {
  return <h2>Welcome to the Dashboard!</h2>;
};

export default Home;
